import { useEffect, useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import StatsBar from './components/StatsBar';
import LiveFeed from './components/LiveFeed';
import ExposeIndex from './components/ExposeIndex';
import TopicTimeline from './components/TopicTimeline';
import ArchiveTabs from './components/ArchiveTabs';
import CommentWall from './components/CommentWall';
import CtaFollow from './components/CtaFollow';
import Footer from './components/Footer';

export default function Home() {
  const [showTop, setShowTop] = useState(false);
  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 700);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Header />
      <main id="top">
        <Hero />
        <StatsBar />
        <LiveFeed />
        <ExposeIndex />
        <TopicTimeline />
        <ArchiveTabs />
        <CommentWall />
        <CtaFollow />
      </main>
      <Footer />

      {showTop && (
        <a
          href="#top"
          className="fixed bottom-6 right-5 z-50 flex h-11 w-11 items-center justify-center rounded-full border border-background-300/70 bg-background-50 text-primary-600 transition-all hover:border-primary-300 hover:bg-primary-50 md:right-8"
          aria-label="回到顶部"
        >
          <i className="ri-arrow-up-line text-lg"></i>
        </a>
      )}
    </div>
  );
}